import { response_type } from "../interfaces";

// 注意事項：
// 1. 只能用 ES6 以下語法 (不能使用 async, await, spread operator(...))

declare const get_db: (db_name: string, list: { url: string; kind?: string }[] | undefined) => Promise<any>;
declare const set_db: (db_name: string, list: { url: string; kind?: string }[] | undefined, value: any) => Promise<void>;
declare const self: { db_version: { [key: string]: number }; db_disabled: boolean };
declare const close: () => void;

export default function db_request(_args: any): void {
  try {
    importScripts("core-js/es/promise");
  } catch (err) {}

  // 宣告接收到訊息時要做的事
  onmessage = (event: MessageEvent): void => {
    // ███╗   ███╗ █████╗ ██╗███╗   ██╗
    // ████╗ ████║██╔══██╗██║████╗  ██║
    // ██╔████╔██║███████║██║██╔██╗ ██║
    // ██║╚██╔╝██║██╔══██║██║██║╚██╗██║
    // ██║ ╚═╝ ██║██║  ██║██║██║ ╚████║
    // ╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝
    // 主             程             式

    const args: [number, string, string, any] = JSON.parse(event.data);
    self.db_version = {};
    self.db_disabled = false;
    get_db(`${args[1]}_version`, [{ url: "version" }]).then((version: string[]) => {
      version[0] && (self.db_version[args[1]] = Number(version[0]));

      if (args[1]) {
        (args[0] ? set_db(args[1], [{ url: args[2] }], args[3]) : get_db(args[1], [{ url: args[2] }]))
          .then((response: response_type) => {
            postMessage(JSON.stringify(response));
            setTimeout(() => {
              close();
            }, 0); // 結束 Worker
          })
          .catch((err) => {
            console.error(err);
          });
      }
    });
  };
}
